import { useBoolean } from '@chakra-ui/react';
import React from 'react';
import FileViewer from '../../../components/pdf_viewer/FileViewer';
import { EyeAvatarIcon } from '../../../constants/IconData';
import { useAuditReportAttachment } from '../../../components/pdf_viewer/AuditReportViewer';

const FileViewAction = ({ auditUpload, chart_id=null }) => {
  const [isFileOpen, ifoState] = useBoolean(false);
  const { attachment } = useAuditReportAttachment({ chartId: chart_id });

  return (
    <React.Fragment>
      <EyeAvatarIcon
        style={{ cursor: 'pointer', width: '40px', height: '40px' }}
        onClick={ifoState.on}
        transition={'all .25s ease-in-out'}
      />
      <FileViewer
        isOpen={isFileOpen}
        currentFile={auditUpload?.file_obj}
        attachments={[
          ...(auditUpload?.attachments || []),
          ...(chart_id && attachment ? [attachment] : [])
        ]}
        onClose={ifoState.off}
      />
    </React.Fragment>
  );
};

export default FileViewAction;
